module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-3.6e4ab7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-3.jpg
// module id = v1rk
// module chunks = 1